import React from 'react';
 
const NoPageFound = () => {
    return (
       <div>
          <br />
          <h3 style={{color: "grey"}}>Error: Page does not exist! <span role="img" aria-label="disappointed face" >😞</span></h3>
       </div>
    );
}
 
export default NoPageFound;